<template lang="pug">
  ul.side-bottom-list.list-reset.flex.flex-wrap.items-start
    li.col-6.flex.items-start.justify-between(v-for="item, idx in data", :key="item.id")
      .col-5.primary-img.relative(data-ratio="16/9")
        a(:href="item.origin_url", target="_blank")
          img.fit(:src="shift(item.o_pic_list[0])")
      .col-7.primary-info.px1
        a(:href="item.origin_url", target="_blank")
          .item-title.fs-14(:title="item.title", data-clamp="3") {{ item.title }}
        .sub.col-12
          | {{ item.pub_source }}
          span.px1 |
          | {{ formatUtc(item.pub_utc) }}
</template>

<script>
import moment from "moment";

import transformImgLink from "@/assets/utils/transformImgLink";
export default {
  props: ["data"],
  methods: {
    shift(link) {
      return transformImgLink(link);
    },
    formatUtc(utc) {
      return moment.unix(utc).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../assets/variables.styl';
.side-bottom-list
  >li
    &:nth-child(n+3)
      margin-top 8px
    .primary-img
      overflow hidden
      img
        width 100%
        transform scale(1.5)
        transition-duration 1s
  +below($notebook)
    li
      flex-direction: column
      height 40%
      &:nth-child(2n-1)
        padding-right 5px
      &:nth-child(2n)
        padding-left 5px
      .primary-img,
      .primary-info
        width 100%
      .primary-info
        padding: .5rem 0
</style>



// WEBPACK FOOTER //
// sideBottomList.vue?7cde5628